module.exports = __webpack_public_path__ + "static/media/student1.fd743403.svg";